/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RoleDto } from './roleDto';
import { CompanyV2Dto } from './companyV2Dto';


export interface UserDto { 
    id?: number;
    uuid?: string;
    firstName?: string;
    lastName?: string;
    dateOfBirth?: string;
    email?: string;
    language?: string;
    enabled?: boolean;
    verified?: boolean;
    company?: CompanyV2Dto;
    role?: RoleDto;
    created?: string;
    lastLogin?: string;
    type?: UserDto.TypeEnum;
}
export namespace UserDto {
    export type TypeEnum = 'OAUTH_APPLE' | 'OAUTH_GOOGLE' | 'REGULAR';
    export const TypeEnum = {
        OauthApple: 'OAUTH_APPLE' as TypeEnum,
        OauthGoogle: 'OAUTH_GOOGLE' as TypeEnum,
        Regular: 'REGULAR' as TypeEnum
    };
}


